var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSitesBlue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.647,
    height: 28.528,
    viewBox: "0 0 20.647 28.528",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_79e13e362b47af4e46839e9fed50e897",
    "data-name": "79e13e362b47af4e46839e9fed50e897",
    transform: "translate(-161.8 -10)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_554",
    "data-name": "Caminho 554",
    d: "M179.422,12.882a10.682,10.682,0,0,0-14.6,0,9.556,9.556,0,0,0-3.025,6.96,9.392,9.392,0,0,0,.833,3.878c.531,1.377,2.439,5.441,8.751,13.828l.739.981.739-.981c6.316-8.387,8.22-12.448,8.751-13.828a9.392,9.392,0,0,0,.833-3.878A9.556,9.556,0,0,0,179.422,12.882Zm-7.3,9.3a3.127,3.127,0,1,1,3.275-3.124A3.2,3.2,0,0,1,172.123,22.183Z",
    fill: "#009ebe"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSitesBlue);
export default __webpack_public_path__ + "static/media/sitesBlue.a5d0c2fd6ee42cf1590c454c94978172.svg";
export { ForwardRef as ReactComponent };